export const checkPermission = (routeRole: any, userRole: any) => {
  if (!routeRole || !routeRole) {
    return true;
  }

  if (userRole && Array.isArray(userRole) && !Array.isArray(routeRole)) {
    return userRole.indexOf(routeRole) >= 0;
  }
  if (routeRole.length === 0) {
    return !userRole || userRole.length === 0;
  }
  if (userRole && Array.isArray(userRole) && Array.isArray(routeRole)) {
    return routeRole.some((r) => userRole.indexOf(r) >= 0);
  }
  return routeRole.indexOf(userRole) >= 0;
};

const rolesForCreateCSP = ['SUPER_ADMIN', 'CSP_BUSINESS', 'CSP_ADMIN'];
const rolesForGetEnterprisesUnderCSP = ['SUPER_ADMIN', 'CSP_BUSINESS', 'CSP_TECHNICAL', 'CSP_ADMIN', 'CSP_READ_ONLY'];
const rolesForGetCSPDetails = ['SUPER_ADMIN', 'CSP_BUSINESS', 'CSP_TECHNICAL', 'CSP_ADMIN'];
const rolesForDeleteEnterprise = ['SUPER_ADMIN', 'CSP_BUSINESS', 'CSP_TECHNICAL', 'CSP_ADMIN'];
const rolesForGetEnterprise = ['SUPER_ADMIN', 'CSP_BUSINESS', 'CSP_TECHNICAL', 'ENTERPRISE_ADMIN', 'CSP_ADMIN', 'CSP_READ_ONLY'];
const rolesForCreateEnterprise = ['SUPER_ADMIN', 'CSP_BUSINESS', 'CSP_TECHNICAL', 'CSP_ADMIN'];
const rolesForCreateMapping = ['SUPER_ADMIN', 'CSP_BUSINESS', 'CSP_TECHNICAL', 'CSP_ADMIN'];
const rolesForDeleteMapping = ['SUPER_ADMIN', 'CSP_BUSINESS', 'CSP_TECHNICAL', 'ENTERPRISE_ADMIN', 'CSP_ADMIN'];
const rolesForUpdateMapping = ['SUPER_ADMIN', 'CSP_BUSINESS', 'CSP_TECHNICAL', 'ENTERPRISE_ADMIN', 'CSP_ADMIN'];
const rolesForAddWebexSettingAtCSPLevel = ['SUPER_ADMIN', 'CSP_BUSINESS'];
const rolesForDeleteWebexSettingAtCSPLevel = ['SUPER_ADMIN', 'CSP_BUSINESS'];
const rolesForAddWebexSettingAtEnterpriseLevel = ['SUPER_ADMIN', 'CSP_BUSINESS', 'CSP_TECHNICAL', 'ENTERPRISE_ADMIN', 'CSP_ADMIN'];
const rolesForDeleteWebexSettingAtEnterpriseLevel = ['SUPER_ADMIN', 'CSP_BUSINESS', 'CSP_TECHNICAL', 'ENTERPRISE_ADMIN', 'CSP_ADMIN'];
const rolesForInviteMapping = ['ENTERPRISE_ADMIN'];

export const checkRoles = (permittedRoles: string[] | undefined, userRoles: string[]) => {
  return permittedRoles ? permittedRoles.some((item) => userRoles.includes(item)) : false;
}

export const checkRolesForCreateCSP = (userRoles: string[]) => {
  return rolesForCreateCSP.some((item) => userRoles.includes(item));
}

export const checkRolesForGetEnterprisesUnderCSP = (userRoles: string[]) => {
  return rolesForGetEnterprisesUnderCSP.some((item) => userRoles.includes(item));
}

export const checkRolesForGetCSPDetails = (userRoles: string[]) => {
  return rolesForGetCSPDetails.some((item) => userRoles.includes(item));
}

export const checkRolesForCreateEnterprise = (userRoles: string[]) => {
  return rolesForCreateEnterprise.some((item) => userRoles.includes(item));
}

export const checkRolesForDeleteEnterprise = (userRoles: string[]) => {
  return rolesForDeleteEnterprise.some((item) => userRoles.includes(item));
}

export const checkRolesForGetEnterprise = (userRoles: string[]) => {
  return rolesForGetEnterprise.some((item) => userRoles.includes(item));
}

export const checkRolesForCreateMapping = (userRoles: string[]) => {
  return rolesForCreateMapping.some((item) => userRoles.includes(item));
}

export const checkRolesForDeleteMapping = (userRoles: string[]) => {
  return rolesForDeleteMapping.some((item) => userRoles.includes(item));
}

export const checkRolesForUpdateMapping = (userRoles: string[]) => {
  return rolesForUpdateMapping.some((item) => userRoles.includes(item));
}

export const checkRolesForAddWebexSettingAtCSPLevel = (userRoles: string[]) => {
  return rolesForAddWebexSettingAtCSPLevel.some((item) => userRoles.includes(item));
}

export const checkRolesForDeleteWebexSettingAtCSPLevel = (userRoles: string[]) => {
  return rolesForDeleteWebexSettingAtCSPLevel.some((item) => userRoles.includes(item));
}

export const checkRolesForAddWebexSettingAtEnterpriseLevel = (userRoles: string[]) => {
  return rolesForAddWebexSettingAtEnterpriseLevel.some((item) => userRoles.includes(item));
}

export const checkRolesForDeleteWebexSettingAtEnterpriseLevel = (userRoles: string[]) => {
  return rolesForDeleteWebexSettingAtEnterpriseLevel.some((item) => userRoles.includes(item));
}

export const checkRolesForInviteMapping = (userRoles: string[]) => {
  return rolesForInviteMapping.some((item) => userRoles.includes(item));
}
